import { useMemo } from 'react'
import {
  ERROR_CODE_EXPIRED,
  ERROR_INVITE_CODE_EXPIRED,
  ERROR_INVITE_CODE_EXPIRED_AND_RESENT,
  ERROR_INVITE_CODE_EXPIRED_NO_SEAT,
  ERROR_VERIFICATION_CODE_EXPIRED,
} from '../../common/errorCodes'

export interface AuthError {
  message: string
  errorCode: number
  email?: string
}

export interface ExpiredLinkPanelContent {
  title: string
  text: string
}

export const INVITE_LINK_EXPIRED_CODES = [ERROR_INVITE_CODE_EXPIRED_AND_RESENT, ERROR_INVITE_CODE_EXPIRED, ERROR_INVITE_CODE_EXPIRED_NO_SEAT]

export const VERIFICATION_LINK_EXPIRED_CODES = [ERROR_VERIFICATION_CODE_EXPIRED, ERROR_CODE_EXPIRED]

const INVITE_LINK_EXPIRED_TITLE = 'This invite link has expired'
const VERIFICATION_LINK_EXPIRED_TITLE = 'This verification link has expired'
const NEW_LINK_SENT_TEXT = "Check your inbox, we've sent you a new link."

const EXPIRED_LINK_PANELS: Record<number, ExpiredLinkPanelContent> = {
  [ERROR_INVITE_CODE_EXPIRED_AND_RESENT]: { title: INVITE_LINK_EXPIRED_TITLE, text: NEW_LINK_SENT_TEXT },
  [ERROR_INVITE_CODE_EXPIRED]: { title: INVITE_LINK_EXPIRED_TITLE, text: 'Contact the Account Owner and request a new one.' },
  [ERROR_INVITE_CODE_EXPIRED_NO_SEAT]: {
    title: INVITE_LINK_EXPIRED_TITLE,
    text: "Your firm doesn't have a free spot available right now. Contact the person who invited you to get access.",
  },
  [ERROR_VERIFICATION_CODE_EXPIRED]: { title: VERIFICATION_LINK_EXPIRED_TITLE, text: NEW_LINK_SENT_TEXT },
  [ERROR_CODE_EXPIRED]: { title: VERIFICATION_LINK_EXPIRED_TITLE, text: NEW_LINK_SENT_TEXT },
}

const useExpiredLinkPanel = (authErrors?: AuthError[] | null, codes: number[] = INVITE_LINK_EXPIRED_CODES): ExpiredLinkPanelContent | undefined => {
  return useMemo(() => {
    const expired = authErrors?.find((error) => codes.includes(error.errorCode))
    return expired && EXPIRED_LINK_PANELS[expired.errorCode]
  }, [authErrors, codes])
}

export default useExpiredLinkPanel
